import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Label,
  ResponsiveContainer,
} from "recharts";
import "../SevenBarChart/SevenBarChart.css";

// Sample data
const data = [
  { date: "Mon", reports: 5000 },
  { date: "Tue", reports: 3000 },
  { date: "Wed", reports: 8000 },
  { date: "Thu", reports: 2000 },
  { date: "Fri", reports: 5500 },
  { date: "Sat", reports: 3500 },
  { date: "Sun", reports: 6000 },
];

// Custom bar shape to add border radius and shadow
const CustomBar = (props) => {
  const { fill, x, y, width, height } = props;
  const radius = 20;

  return (
    <>
      <path
        d={`M${x},${y + radius} 
           a${radius},${radius} 0 0,1 ${radius},-${radius} 
           h${width - radius * 2} 
           a${radius},${radius} 0 0,1 ${radius},${radius} 
           v${height - radius} 
           h-${width} 
           Z`}
        fill={fill}
      />
      <rect
        x={x}
        y={y}
        width={width}
        height={height}
        fill={fill}
        rx={6}
        ry={6}
      />
    </>
  );
};

const SevenBarChart = () => {
  return (
    <>
      <section className="section">
        <div className="bar-container">
          <div className="bar-header">
            <h1>Weekly Stock Analysis Report Counts <sub style={{color: "blue"}}>(Bar chart)</sub></h1>
          </div>

          <div className="bar-parent">
            <div className="bar-count-wrapper">
              <div>
                <i class="fa-solid fa-circle" style={{ color: "#5662be" }}></i>{" "}
                Reports
              </div>
            </div>
            <div className="bar-chart-container">
              <ResponsiveContainer width="100%" height={330}>
                <BarChart
                  data={data}
                  margin={{ top: 0, right: 0, left: 10, bottom: 30 }}
                >
                  {/* Grid Lines */}
                  <CartesianGrid
                    stroke="#d6d6d6"
                    strokeDasharray="0 0"
                    horizontal={true}
                    vertical={false}
                  />

                  {/* X-Axis */}
                  <XAxis
                    dataKey="date"
                    axisLine={true}
                    tickLine={false}
                    tick={{ fontSize: 14, fill: "#999" }}
                  >
                    <Label
                      value="Day of Week"
                      offset={-25}
                      position="insideBottomLeft"
                      textAnchor="start"
                      dx={25}
                      style={{ fontSize: 14, fill: "#999" }}
                    />
                  </XAxis>

                  {/* Y-Axis */}
                  <YAxis
                    axisLine={true}
                    tickLine={false}
                    tick={{ fontSize: 14, fill: "#999" }}
                  >
                    <Label
                      value="Count of Reports"
                      angle={-90}
                      position="left"
                      offset={-20}
                      style={{
                        textAnchor: "middle",
                        fontSize: 14,
                        fill: "#999",
                      }}
                      dx={-20}
                      dy={80}
                    />
                  </YAxis>

                  {/* Tooltip */}
                  <Tooltip
                    cursor={{ fill: "transparent" }}
                    formatter={(value) => [`${value}k`, "Reports Count"]}
                    labelStyle={{
                      fontSize: "14px",
                      color: "#000",
                    }}
                    itemStyle={{
                      fontSize: "14px",
                      color: "#999",
                    }}
                  />

                  {/* Custom Bar */}
                  <Bar
                    dataKey="reports"
                    shape={<CustomBar />} // Custom shape for bars
                    fill="#5662be"
                    barSize={window.innerWidth < 600 ? 25 : 30}
                    onMouseEnter={() => {
                      // Optional: Add custom logic for hover events
                    }}
                    onMouseLeave={() => {
                      // Optional: Add custom logic for hover leave events
                    }}
                  />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SevenBarChart;
